import * as React from 'react';

import ProfileRejectionReason from './steps/rejection-reason/ProfileRejectionReason';
import ProfileRejectionWarning from './steps/rejection-warning/ProfileRejectionWarning';

import type { ActiveCampaign } from 'types';

type Props = {
  influencerCampaigns: Array<ActiveCampaign>,
  onCloseModal: () => void,
  onRejection: (b: string, a: string) => void
};

const RenderSteps = {
  WARNING: 'warning',
  REJECT_PROMPT: 'reject_prompt'
};

const ProfileRejectionModal = (
  {
    influencerCampaigns = [],
    onCloseModal,
    onRejection
  }: Props
): JSX.Element => {
  const initialStep = (influencerCampaigns.length > 0)
    ? RenderSteps.WARNING
    : RenderSteps.REJECT_PROMPT;

  const [currentStep, setStep] = React.useState(initialStep);

  if (currentStep === RenderSteps.WARNING) {
    return (
      <ProfileRejectionWarning
        influencerCampaigns={influencerCampaigns}
        onCloseModal={onCloseModal}
        onContinue={() => setStep(RenderSteps.REJECT_PROMPT)}
      />
    );
  }

  return (
    <ProfileRejectionReason
      onCloseModal={onCloseModal}
      onRejection={onRejection}
    />
  );
};

export default ProfileRejectionModal;
